<template>
    <Head title="My Favorite Lounges" />
    <div class="px-4 md:px-8">
        <Favorites />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Favorites from '@/components/tools/lounges/lounge-favorites/index.vue';
</script>
